import * as types from '../../types'
import {
    API_URL,
    usuarioEntity
} from '../../utils/constants'
import {
    displayMessages,
    setSavingState
} from '../Layout/actions'
import {
    createAxiosInstance
} from '../../utils/helpers'
import {
    tableActions
} from '@mawesi-sas/mws_react_component_table';

export function reiniciarEstado() {
    return (dispatch) => {
        dispatch({
            type: types.USUARIOS_REINICIAR_ESTADO
        })
    }
}

export function getDataFromServer(page = 1) {
    const axios = createAxiosInstance()
    return (dispatch, getState) => {
        const modelo = 'User'
        const include = ['roles']
        const take = 100
        const filter = getState().usuarios.getIn(['filter'])
        const fields = ['username', 'email', 'name', 'area', 'extension', 'active', 'ldap', 'roles.name']
        const filters = []

        if (filter) {
            fields.forEach(x => {
                let f = {
                    field: x,
                    operator: 'like',
                    value: filter
                }
                filters.push(f)
            })
        }
        const skip = (page - 1) * take
        axios.post(`${API_URL}/list`, {
                modelo,
                filters,
                include,
                skip,
                take,
                total: true
            })
            .then((res) => {
                const list = res.data.data.map(x => {
                    x._enabled = true
                    return x
                })
                const records = res.data.total
                dispatch(tableActions.mswTable_mostrarDatos('usuarios', 'usuarios', list, page, records))
            })
            .catch((err) => {
                displayMessages(dispatch, err)
            })
    }
}

export function showHideModalCreate(show, id = null) {
    const axios = createAxiosInstance()
    return (dispatch, getState) => {
        if (!show) {
            dispatch({
                type: types.USUARIOS_MOSTRAR_OCULTAR_MODAL_CREATE,
                payload: {
                    show
                }
            })
            return
        }

        const modelo = 'Role'
        const include = []
        const filters = []

        axios.post(`${API_URL}/list`, {
                modelo,
                filters,
                include,
            })
            .then((res) => {
                const item = id ? getState().usuarios.getIn(`usuarios.data.${id}`.split('.')).toJS() : usuarioEntity()
                item.role_id = item.roles.length ? item.roles[0].id : null
                const roles = res.data.map(x => {
                    return {
                        caption: x.name,
                        value: x.id
                    }
                })
                dispatch({
                    type: types.USUARIOS_MOSTRAR_OCULTAR_MODAL_CREATE,
                    payload: {
                        show,
                        item,
                        roles
                    }
                })
            })
            .catch((err) => {
                console.log(err)
                displayMessages(dispatch, err)
            })
    }
}

export function guardarUsuario() {
    const axios = createAxiosInstance()
    return (dispatch, getState) => {
        dispatch(setSavingState('usuarios', true))
        let data = getState().usuarios.getIn(['modalCreate', 'data'])

        const v = String(data.get('active')) === "true"
        data = data.set('active', v ? true : false)

        const id = data.get('id3n71f13r')

        axios.post(`${API_URL}/usuarios`, data)
            .then(res => {
                const usuario = res.data
                usuario._enabled = true
                usuario.id3n71f13r = id
                usuario.role_id = usuario.roles[0].id

                dispatch({
                    type: types.USUARIOS_ACTUALIZAR_REGISTROS,
                    payload: {
                        item: usuario,
                        id
                    }
                })
                dispatch(tableActions.mwsTable_recalcularAnchoColumnas('usuarios', 'usuarios'))
                dispatch(showHideModalCreate(false))
                dispatch(setSavingState('usuarios', false))
                displayMessages(dispatch, {
                    success: 'Los registros han sido guardados exitosamente'
                })
            })
            .catch(err => {
                console.log(err)
                dispatch(setSavingState('parametros', false))
                displayMessages(dispatch, err)
            })

    }
}